/*
 * @Author       : QLing
 * @desc         : 组件描述
 * @Date         : 2025-11-10 09:35:11
 * @LastEditTime : 2025-11-10 09:53:11
 * @LastEditors  : QLing
 * @FilePath     : /evalute-all/teaching_QualityService/src/util/renderEllipsisHeader.js
 */
import Vue from 'vue'

/**
 * 通用表头渲染函数
 * 用于 Element Plus el-table 的 column.renderHeader
 * 实现：表头最多显示多行，超出显示省略号，悬浮显示完整内容
 */

Vue.prototype.$renderEllipsisHeader = (maxLines = 3) => {
    return (h, { column }) => {
        const style = {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: maxLines,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            lineHeight: '20px',
            maxHeight: `${20 * maxLines}px`,
            wordBreak: 'break-word'
        }
        return h(
            'div',
            {
                style,
                attrs: { title: column.label }, // 悬浮提示完整内容
                class: 'header-ellipsis'
            },
            column.label
        )
    }
}



// WEBPACK FOOTER //
// ./src/util/renderEllipsisHeader.js